import {
  GradeEstimatorRequestDto,
  GradeEstimatorResponseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useMutation } from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_ESTIMATE_GRADES = "ESTIMATE_GRADES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const estimateGrades = async (
  dto: GradeEstimatorRequestDto,
): Promise<GradeEstimatorResponseDto[]> => {
  const token = localStorage.getItem("access_token") || "";
  const response = await paygapApi.paygapControllerEstimateGrades(
    `Bearer ${token}`,
    dto,
  );

  return response.data;
};

export const useEstimateGrades = (
  user: UserProfileDto | null,
): {
  estimateGrades: (
    dto: GradeEstimatorRequestDto,
  ) => Promise<GradeEstimatorResponseDto[]>;
  estimateGradesEnabled: boolean;
  isPendingEstimateGrades: boolean;
  isSuccessEstimateGrades: boolean;
  estimateGradesError: Error | null;
  resetEstimateGrades: () => void;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const mutation = useMutation<
    GradeEstimatorResponseDto[],
    Error,
    GradeEstimatorRequestDto
  >({
    mutationKey: [DOMAIN_PAYGAP, ACTION_ESTIMATE_GRADES],
    mutationFn: enabled
      ? estimateGrades
      : async (): Promise<GradeEstimatorResponseDto[]> => {
          throw new Error(
            "Insufficient permissions to estimate grades. Required roles: Owner or Manager.",
          );
        },
  });

  return {
    estimateGrades: (dto: GradeEstimatorRequestDto) => mutation.mutateAsync(dto),
    estimateGradesEnabled: enabled,
    isPendingEstimateGrades: mutation.isPending,
    isSuccessEstimateGrades: mutation.isSuccess,
    estimateGradesError: mutation.error,
    resetEstimateGrades: mutation.reset,
  };
};
